import { Storage } from '../../../constants/storage';

export const ASSISTANT_MODES = {
    FULLSCREEN: 'fullscreen',
    SIDEBAR: 'sidebar',
    FLOATING: 'floating',
    DOCK: 'dock',
    FRAMLESS: 'framless',
};

export const ASSISTANT_MODE_LIST = Object.values(ASSISTANT_MODES);

export const MODE_LABELS = {
    [ASSISTANT_MODES.FULLSCREEN]: 'Full screen',
    [ASSISTANT_MODES.SIDEBAR]: 'Sidebar',
    [ASSISTANT_MODES.FLOATING]: 'Floating',
    [ASSISTANT_MODES.DOCK]: 'Dock dưới',
    [ASSISTANT_MODES.FRAMLESS]: 'Frameless',
};

export const DEFAULT_FLOATING_SIZE = {
    width: 420,
    height: 720,
};

export const FLOATING_MIN_SIZE = {
    width: 360,
    height: 600,
};

export const FLOATING_ANCHOR_OFFSET = 24;

export const DEFAULT_SIDEBAR_WIDTH = 440;
export const SIDEBAR_MIN_WIDTH = 453;
export const SIDEBAR_MAX_WIDTH = 720;

export const DOCK_PILL_WIDTH = 440;
export const DOCK_PILL_HEIGHT = 44;
export const DOCK_PANEL_WIDTH = 780;
export const DOCK_PANEL_HEIGHT = 320;
export const DOCK_BOTTOM_OFFSET = 12;

export const STORAGE_KEYS = {
    MODE: Storage.assistant_mode,
    FLOATING_SIZE: Storage.assistant_floating_size,
    SIDEBAR_WIDTH: Storage.assistant_sidebar_width,
    LAST_SESSION: Storage.assistant_last_session,
    IS_OPEN: Storage.assistant_is_open,
};
